import PlayWithCoinsScreen from '../screens/PlayWithCoinsScreen/PlayWithCoinsScreen';

function PlayWithCoinsPage() {
  return <PlayWithCoinsScreen />;
}

export default PlayWithCoinsPage;
